import { Component, Prop, Vue } from 'vue-property-decorator';
import { IDeliveryAddressViewModel} from "Components/Ecom/Checkout/Shipping/DeliveryAddress";

@Component({
})
export default class ShippingComponent extends Vue {

    public deliveryAddress: IDeliveryAddressViewModel = <IDeliveryAddressViewModel> {
        canSave: false
    };


    public updateDeliveryAddress(value: IDeliveryAddressViewModel) {
        this.deliveryAddress = Object.assign({},value); //clone object
        this.deliveryAddress.canSave = true;
    }

    //THIS IS NOT WORKING - ISSUE: MSO if the first selected item is NOT allowed to be saved the render-engine DOES not change the tag
    get isDeliveryAddressDisabled(){
        if(this.deliveryAddress.canSave == null) return true;

        return !this.deliveryAddress.canSave;
    }
}
Vue.component('shipping', ShippingComponent);